export default __webpack_public_path__ + "static/media/ico_discount.56a741fb.png";